import { Component } from '@angular/core';
import { LoginService } from '../security/login.service';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessagesModule } from 'primeng/messages';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-post-logout',
  standalone: true,
  imports: [ButtonModule, CardModule, MessagesModule],
  templateUrl: './post-logout.component.html',
  styleUrl: './post-logout.component.css'
})
export class PostLogoutComponent {
  constructor(
    private loginService: LoginService,
    private router: Router
  ) {
    this.loginService.activatedNavigationComponent = false;
  }

  messages: Message[] = [{id: 1, summary: "Logout", detail: "You have been successfully logged out.", severity: "success"}];

  login() {
    this.router.navigate(["/login"]);
  }

}
